import { render } from "./EmployeeUsers.vue?vue&type=template&id=1d374939"
import script from "./EmployeeUsers.vue?vue&type=script&lang=js"
export * from "./EmployeeUsers.vue?vue&type=script&lang=js"
script.render = render

export default script